import { render, staticRenderFns } from "./UkrTreasuresPayPalButtonsTable.vue?vue&type=template&id=ce1752ee&scoped=true"
import script from "./UkrTreasuresPayPalButtonsTable.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresPayPalButtonsTable.vue?vue&type=script&lang=js"
import style0 from "./UkrTreasuresPayPalButtonsTable.vue?vue&type=style&index=0&id=ce1752ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1752ee",
  null
  
)

export default component.exports